export const writingStyles = ["Professional", "Casual"]

// Credit weights constant
export const CREDIT_WEIGHTS: Record<string, number> = {
  title: 20,
  description: 50,
  altText: 20,
  seo: 50,
  metaFields: 10,
  marketRadar: 1000,
  image_finder: 200,
  categoryPlacement: 10,
  productTags: 10,
};

export const titleStorageKey = "textarea_title_prompt";
export const descriptionStorageKey = "textarea_description_prompt";
export const seoStorageKey = "textarea_seo_prompt";
export const altTextStorageKey = "textarea_alt_text_prompt";
export const tagsStorageKey = "textarea_tags_prompt";